<div style="margin-left: -1.5rem !important; margin-right: -1.5rem !important">
  <div class="box-white-rounded-xs p-3 px-4">
    <div
      class="row justify-content-center align-items-center pointer-hov"
      [attr.aria-expanded]="isOpen"
      (click)="toggle()"
    >
      <div class="col">
        <h3 class="m-0 fw-normal">{{ title }}</h3>
      </div>
      <div class="col-auto pe-0">
        <div
          class="bg-orange d-inline-block bg-orange"
          [class.invisible]="!warning"
          style="height: 30px; width: 30px; border-radius: 50%"
        >
          <div class="row m-0 h-100 align-items-center">
            <div class="col p-0 text-center color-white">
              <i
                class="fa-solid fa-exclamation-triangle color-white"
                style="position: relative; top: 2px"
              ></i>
            </div>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <i
          class="fa-regular fs-20 transition-transform color-primary"
          [class.fa-angle-up]="isOpen"
          [class.fa-angle-down]="!isOpen"
        ></i>
      </div>
    </div>

    <div class="expandable-content" [class.open]="isOpen">
      <div class="row">
        <div class="col-12 mt-4">
          <ng-content select="[slot=contenu]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
